@if (state.node) {
  <dojo-selectable-tree-cell
    [node]="state.node"
    [expanded]="state.expanded"
    [selected]="state.selected"
    [indeterminate]="state.indeterminate"
    [nestingLevel]="state.nestingLevel"
    [isGroup]="state.isGroup"
    (checkboxChange)="onCheckboxChange($event)"
  >
    <!-- Verification Status Indicator -->
    @if (state.verificationStatus) {
      <span class="scale-120 shrink-0" [matTooltip]="state.verificationTooltip">
        @if (state.verificationStatus === 'verified') {
          <!-- 2+ reviewers: badge-check icon in green -->
          <dojo-icon [icon]="'badge-check'" [size]="'m'" class="text-green-500"></dojo-icon>
        } @else if (state.verificationStatus === 'partial') {
          <!-- 1 reviewer: badge icon in amber -->
          <dojo-icon [icon]="'badge'" [size]="'m'" class="text-amber-500"></dojo-icon>
        } @else {
          <!-- No reviewers: badge icon in red -->
          <dojo-icon [icon]="'badge'" [size]="'m'" class="text-red-400"></dojo-icon>
        }
      </span>
    } @else {
      <!-- Fallback to original icon if no verification status -->
      @if (state.node.originalData?.icon) {
        <dojo-icon
          [icon]="state.node!.originalData!.icon!"
          [size]="'m'"
          class="text-gray-500"
          [style.color]="state.node!.originalData!.color"
        />
      }
    }
  </dojo-selectable-tree-cell>
}
